import Button from 'antd/lib/button'
import classNames from 'classnames'
import React, { useContext } from 'react'
import ImageWithBasePath from '../components/ImageWithBasePath'
import useTranslation from '../hooks/useTranslation'
import { SharedContext } from '@/context/SharedContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'

export const PostJobSteps = ({ presentStep = 1, isCPMFlow = false }) => {
  const translation = useTranslation()
  const stepDetails = [
    { id: 1, title: translation?.postJobSteps?.jobDetail },
    { id: 0, title: 'dash' },
    { id: 2, title: translation?.postJobSteps?.candidateRequirement },
    { id: 0, title: 'dash' },
    { id: 3, title: translation?.postJobSteps?.companyDetail },
    { id: 0, title: 'dash' },
    { id: 4, title: translation?.postJobSteps?.choosePlan }
  ]
  const { windowSize } = useContext(SharedContext);
  const { enterpriseLoginDetails, variant } = useContext(AdvertiserContext);

  const steps = enterpriseLoginDetails?.advertiserId || variant == "pay_later" ? stepDetails.slice(0, 5) : stepDetails

  return (
    <div
      className={classNames(
        ' flex justify-between border-[0px] border-solid border-[#CBCCCE]  font-noto-sans  md:border-[0px] md:pt-[24px] md:pb-[32px]',
        isCPMFlow && 'mx-[8px]  pt-[24px] pb-[32px]',
        !isCPMFlow && 'mx-xl py-24 md:mx-[0px]'
      )}
    >
      {steps?.map((item, index) => {
        const isCurrentStep = presentStep === item?.id

        return (
          <div key={index}>
            {item?.id === 0 ? (
              <div
                key={index}
                className={classNames(
                  'sm:w-30  mt-[18.5px] flex h-[2px] w-[10vw] bg-[#CBCCCE] ',
                  enterpriseLoginDetails?.advertiserId ? '' : 'md:w-30',
                  isCPMFlow && windowSize > 640 ? 'w-[90px]' : 'flex flex-1 items-center'
                )}
              ></div>
            ) : (
              <div
                key={index}
                className={classNames(
                  'flex h-full flex-none flex-col items-center  text-center  w-[50px]  sm:w-[86px] lg:w-[86px]',
                  isCPMFlow && 'space-y-[8px]',
                  !isCPMFlow && 'space-y-[8.5px]'
                )}
              >
                {presentStep > item?.id ? (
                  <ImageWithBasePath
                    src="post_job_success"
                    width={36}
                    height={36}
                    className=" rounded-full bg-white"
                    alt="job success image"
                  />
                ) : (
                  <Button
                    disabled={!isCurrentStep}
                    className="flex h-[36px] w-[36px] items-center justify-center rounded-full border-[2px] border-solid border-[#FFBB00] bg-[#FFF1CC] text-md font-bold leading-[21.79px] text-[#333436] disabled:border-[0px] disabled:bg-[#E5E5E5] disabled:leading-[18.75px] disabled:text-[#97989B]"
                  >
                    <div>{item?.id}</div>
                  </Button>
                )}
                <div
                  className={classNames(
                    'text-sm ',
                    isCurrentStep
                      ? 'leading-normal font-bold text-[#333436]'
                      : 'font-normal text-[#66676B]',
                    isCPMFlow && !isCurrentStep && 'leading-normal font-normal ',
                    !isCPMFlow && 'leading-[16.34px] text-[#333436]',
                    isCPMFlow && windowSize > 640 ? 'text-[#666]' : 'text-[#595959]'
                  )}
                >
                  {item?.title}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
